import HatSchool from '../../assets/icons/hatSchool.svg';
import IconStar from '../../assets/icons/iconStar.svg';
import IconMap from '../../assets/icons/iconMap.svg';
import usersIcon from '../../assets/images/users.svg';
import AdminMenuOpt1 from '../../assets/images/admin-opt-1.png';
import AdminMenuOpt2 from '../../assets/images/admin-opt-2.png';
import AdminMenuOpt3 from '../../assets/images/admin-opt-3.png';
import AdminMenuOpt4 from '../../assets/images/admin-opt-4.png';

import './style.scss';
import { Link } from 'react-router-dom';

function AdminSchoolMenu() {
  return (
    <section className='admin-menu'>
      <div className='admin-menu__wrapper content'>
        <Link to={'/administrador/menu'} className='content__item item'>
          <div className='item__def def'>
            <span className='def__text'>
              Escuelas de Participación Ciudadana
            </span>
            <img src={HatSchool} alt='opt-1-icon' className='def__icon' />
          </div>
          <img src={AdminMenuOpt1} alt='opt-1' className='item__img' />
        </Link>
        <div className='content__item item'>
          <div className='item__def def'>
            <span className='def__text'>Centro de Orientación Pedagógica</span>
            <img src={IconStar} alt='opt-1-icon' className='def__icon' />
          </div>
          <img src={AdminMenuOpt2} alt='opt-1' className='item__img' />
        </div>
        <div className='content__item item'>
          <div className='item__def def'>
            <span className='def__text'>Consejos Estudiantiles Comunales</span>
            <img src={IconMap} alt='opt-1-icon' className='def__icon' />
          </div>
          <img src={AdminMenuOpt3} alt='opt-1' className='item__img' />
        </div>
        <Link to={'/administrador/usuarios'} className='content__item item'>
          <div className='item__def def'>
            <span className='def__text'>Usuarios</span>
            <img src={usersIcon} alt='opt-1-icon' className='def__icon' />
          </div>
          <img src={AdminMenuOpt4} alt='opt-1' className='item__img' />
        </Link>
      </div>
    </section>
  );
}

export default AdminSchoolMenu;
